import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ef90fa8")

_pushScopeId("data-v-1ef90fa8")
const _hoisted_1 = {
  class: "name",
  style: {"font-weight":"400"}
}
const _hoisted_2 = {
  class: "f-xs",
  style: {"line-height":"1"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Donut = _resolveComponent("Donut")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", {
    class: ["button df-middle df-between px-8 br-lg", {on: _ctx.on}]
  }, [
    _createVNode("div", null, [
      _createVNode("p", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createVNode("p", _hoisted_2, [
        _renderSlot(_ctx.$slots, "suffix", {}, undefined, true)
      ])
    ]),
    (_ctx.progress)
      ? (_openBlock(), _createBlock(_component_Donut, { key: 0 }))
      : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          class: "icon",
          name: _ctx.on ? 'minus': 'plus',
          sm: ""
        }, null, 8, ["name"]))
  ], 2))
})